import { Breadcrumbs, Placeholder } from '../../index'

const DefaultTemplate = ({ page, placeholder }) => {
  return (
    <main className="cms-page cms-page--default">
      <div className="w-container">
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        <Placeholder placeholder={placeholder} />
      </div>
    </main>
  )
}

export default DefaultTemplate
